import React from "react";
import { graphql } from "gatsby";
import Banner from "./banner";
import { useCollectAnchorLinks } from "../../context/anchorLinksContextProvider";

const Gallery = ({ gallery, blockIndex = null }) => {
  const Anchor = gallery?.anchor ?? gallery?.id;
  useCollectAnchorLinks(null, gallery?.anchor, blockIndex);

  // title={card.title}
  // bannerType="Card-Gallery"
  // bodyCopy={card.bodyCopy}
  // buttonText={card.buttonText}
  // buttonLink={card.buttonLink}
  // backgroundColor={card.backgroundColor}
  // bannerImage={card.bannerImage}
  return gallery.cardGallery.length > 0 ? (
    <div className="card-gallery" id={Anchor}>
      {gallery.cardGallery.map((card, index) => {
        card.bannerType = "Card-Gallery";
        return <Banner bannerData={card} key={`card-gallery-${index}`} />;
      })}
    </div>
  ) : (
    ""
  );
};

export default Gallery;

export const query = graphql`
  fragment Gallery on ContentfulCardGallery {
    id
    anchor
    cardGallery {
      ...Banner
    }
  }
`;
